import { useActiveWeb3React } from 'hooks'
import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useETHBalances } from 'state/wallet/hooks'
import { ReactComponent as LogoType } from '../../assets/svg/logotype.svg'
import { ReactComponent as MenuIcon } from '../../assets/svg/ico_menu_2.svg'
import { useDrawerToggler } from '../../state/application/hooks'
import Web3Status from '../Web3Status'
import Menu from './Menu'
import {
  AccountElement,
  BalanceText,
  BrandWrapper,
  Flex,
  Hamburger,
  Navbar,
  NavbarWrapper,
  MenuIconWrapper
} from './styled'
import Container from 'elements/Container'
import { fetchBoxycats } from 'state/boxycats/actions/fetchBoxycats'
import { useDispatch } from 'react-redux'
import NetworkSelector from './NetworkSelector'

function Header(): JSX.Element {
  const { account, chainId } = useActiveWeb3React()
  const location = useLocation()
  const DrawerToggler = useDrawerToggler()
  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  const isIndexPage = location.pathname === '/'
  const dispatch = useDispatch()

  useEffect(() => {
    if (account) dispatch(fetchBoxycats(account))
  }, [chainId, account, dispatch])

  const Nav = () => {
    return (
      <Navbar>
        <Hamburger>
          {!isIndexPage && (
            <MenuIconWrapper style={{ cursor: 'pointer' }} onClick={DrawerToggler}>
              <MenuIcon style={{ width: '20px', height: '20px' }} />
            </MenuIconWrapper>
          )}
        </Hamburger>
        <BrandWrapper>
          <Link style={{ display: 'flex' }} to="/">
            <LogoType
              style={{
                height: isIndexPage ? '48px' : '30px',
                width: 'auto'
              }}
            />
          </Link>
        </BrandWrapper>
        <Flex>
          <NetworkSelector />
          <AccountElement active={!!account} style={{ pointerEvents: 'auto' }}>
            {account && userEthBalance ? (
              <BalanceText style={{ flexShrink: 0 }}>{userEthBalance?.toSignificant(4)} ETH</BalanceText>
            ) : null}
            <Web3Status />
          </AccountElement>
          <Menu />
        </Flex>
      </Navbar>
    )
  }

  return (
    <NavbarWrapper isIndexPage={isIndexPage}>
      {isIndexPage ? (
        <Container style={{ margin: 0 }}>
          <Nav />
        </Container>
      ) : (
        <Nav />
      )}
    </NavbarWrapper>
  )
}

export default Header
